require("./styles/index.scss");
import jQuery from "jquery";
import slick from "slick-carousel";
import gsap from "gsap";
import { pillsAnimation } from "./assets/js/pills-animation";
import { testimonialLogic } from "./assets/js/testimonial-logic";
import { carouselWithButtons } from "./assets/js/carousel-with-buttons";

jQuery(($) => {
  const $win = $(window);
  // *****************
  //Hide and show cookies bar
  // *****************
  if (
    localStorage.cookie_consented === undefined ||
    localStorage.cookie_consented === null ||
    localStorage.cookie_consented === false
  ) {
    setTimeout(() => {
      $("#cookies-consent").addClass("show");
    }, 1000);
  }
  $("#accept-cookies-consent").on("click", function () {
    $("#cookies-consent").removeClass("show");
    localStorage.setItem("cookie_consented", true);
  });

  // *****************
  // Added this so that Gsap can set the opacity of elements to 0 on load
  // and we won't see a flash of the element
  // *****************
  // $("body").css("opacity", 1);

  // *****************
  // Disable scrolling
  // *****************
  const noScroll = (disable) => {
    const scrollY =
      document.documentElement.style.getPropertyValue("--scroll-y");
    const body = document.body;
    if (disable) {
      body.style.position = "fixed";
      body.style.top = `-${scrollY}`;
    } else {
      const scrollY = body.style.top;
      body.style.position = "";
      body.style.top = "";
      window.scrollTo(0, parseInt(scrollY || "0") * -1);
    }
  };
  window.addEventListener("scroll", () => {
    document.documentElement.style.setProperty(
      "--scroll-y",
      `${window.scrollY}px`
    );
  });

  // *****************
  // Hide and show slide out menu
  // *****************
  $("#menu-toggle").on("click", function (e) {
    e.preventDefault();
    console.log(window.scrollY);
    if (
      $(".slide-out-menu-container").hasClass("show") ||
      $(".slide-out-sub-menu-container").hasClass("show")
    ) {
      // Close slide out menu
      $(".slide-out-menu-container").removeClass("show");
      $(".slide-out-sub-menu-container").removeClass("show");
      noScroll(false);
    } else {
      // Open Close slide out menu
      $(".slide-out-menu-container").addClass("show");
      noScroll(true);
    }

    const isChecked = $("#menu-toggle-checkbox").is(":checked");
    if (isChecked) {
      $("#menu-toggle-checkbox").prop("checked", false);
    } else {
      $("#menu-toggle-checkbox").prop("checked", true);
    }

    $("body").toggleClass("no-scroll");
  });

  $("input").each(function () {
    $(this).prop("checked", false);
  });

  $(".slide-out-menu-container .has-sub-menu").on("click", function () {
    var section = $(this).data("section");
    $('.slide-out-sub-menu-container[data-section="' + section + '"]').addClass(
      "show"
    );
  });

  $(".slide-out-sub-menu-container .close-btn").on("click", function () {
    $(".slide-out-sub-menu-container").removeClass("show");
    $(".slide-out-menu-container").addClass("show");
  });

  $("button").on("click", function (e) {
    e.preventDefault();
  });

  // *****************
  //hide and show info about team memembers
  // *****************
  $(".expand-info-btn").on("click", function (e) {
    e.preventDefault();
    const aboutButton = $(this);
    const aboutContainer = $(this).siblings(".about");
    if (aboutContainer.hasClass("expand")) {
      aboutButton.html("Learn more");
      aboutContainer.removeClass("expand");
    } else {
      aboutButton.html("Close");
      aboutContainer.addClass("expand");
    }
  });

  // *****************
  //Hide and show service section content
  // *****************
  const expandService = (element, event) => {
    event.preventDefault();
    // event.stopImmediatePropagation();
    event.stopPropagation();
    const serviceContainer = element.parent();
    const serviceWrapper = element.siblings(".service-content-wrapper");
    const serviceContent = serviceWrapper.children(".service-content")[0];
    const serviceContentLinks = serviceWrapper.find(
      ".service-content .service-links .link"
    );
    const serviceContentHeight = serviceContent && serviceContent.clientHeight;

    console.log(serviceContentLinks);
    if (serviceContainer.hasClass("expand")) {
      serviceWrapper.removeAttr("style");
      serviceContainer.removeClass("expand");
      serviceContentLinks.attr("tabindex", -1);
    } else {
      serviceWrapper[0].style.maxHeight = serviceContentHeight + "px";
      serviceContainer.addClass("expand");
      serviceContentLinks.attr("tabindex", 0);
    }
  };
  $(".service-name").on("click", function (e) {
    expandService($(this), e);
  });

  if (window.innerWidth > 992) {
    $(".button-nav-cta").html("Book");
  } else {
    $(".button-nav-cta").html("Book");
  }

  // $(".review-carousel").slick({
  //   infinite: false,
  //   arrows: false,
  //   variable: false,
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  //   focusOnSelect: true,
  // });

  // const numOfRelatedVidoes = $(".related-video").length;
  // const relatedVideosOffset = window.innerWidth >= 768 ? 2 : 0;
  // const relatedVideosCarousel = $(".related-videos-carousel").slick({
  //   infinite: false,
  //   arrows: false,
  //   variable: false,
  //   slidesToShow: 3,
  //   slidesToScroll: 1,
  //   responsive: [
  //     {
  //       breakpoint: 768,
  //       settings: {
  //         slidesToShow: 1,
  //       },
  //     },
  //   ],
  // });
  // const relatedVideosCarouselArrows = $(".related-videos .arrow");
  // const relatedVideosCarouselPrevArrow = $(".related-videos .arrow--prev");
  // const relatedVideosCarouselNextArrow = $(".related-videos .arrow--next");
  // relatedVideosCarouselPrevArrow.on("click keydown", function (e) {
  //   var keyCode = e.keyCode ? e.keyCode || e.which : null;
  //   if (e.type === "click" || (e.type === "keydown" && keyCode == 13)) {
  //     relatedVideosCarousel.slick("slickPrev");
  //   }
  // });
  // relatedVideosCarouselNextArrow.on("click keydown", function (e) {
  //   var keyCode = e.keyCode ? e.keyCode || e.which : null;
  //   if (e.type === "click" || (e.type === "keydown" && keyCode == 13)) {
  //     relatedVideosCarousel.slick("slickNext");
  //   }
  // });

  // relatedVideosCarouselNextArrow.attr("tabindex", 0);
  // relatedVideosCarouselPrevArrow.attr("tabindex", 0);
  // relatedVideosCarousel.on(
  //   "beforeChange",
  //   function (event, slick, currentSlide, nextSlide) {
  //     if (nextSlide === 0) {
  //       relatedVideosCarouselPrevArrow.addClass("disabled");
  //     } else if (nextSlide === numOfRelatedVidoes - 1 - relatedVideosOffset) {
  //       relatedVideosCarouselNextArrow.addClass("disabled");
  //     } else {
  //       relatedVideosCarouselPrevArrow.removeClass("disabled");
  //       relatedVideosCarouselNextArrow.removeClass("disabled");
  //     }
  //   }
  // );
  // *****************
  // Functions to hide and show related-video control if smaller than window
  // *****************
  // const showHideRelatedVideoArrows = () => {
  //   if (relatedVideosCarousel.length > 0) {
  //     if (
  //       $(".related-videos-carousel .slick-track").width() > window.innerWidth
  //     ) {
  //       relatedVideosCarouselArrows.show();
  //     } else {
  //       relatedVideosCarouselArrows.hide();
  //     }
  //   }
  // };

  // *****************
  // Functions to scroll timeline module
  // *****************
  $(".timeline-container .prev").on("click", function () {
    const timelinePos = $(".timeline-wrapper").scrollLeft();
    $(".timeline-wrapper").animate({ scrollLeft: timelinePos - 250 }, 250);
  });
  $(".timeline-container .next").on("click", function () {
    const timelinePos = $(".timeline-wrapper").scrollLeft();
    $(".timeline-wrapper").animate({ scrollLeft: timelinePos + 250 }, 250);
  });

  // *****************
  // Disable scrolling if window width is wider than carousel
  // *****************
  const removeTimelineCarouselArrows = () => {
    const timelineCarouselWidth = $(".timeline-carousel").width();
    const timelineCarousel = $(".timeline-container");
    const windowWidth = $(window).width();
    if (windowWidth > timelineCarouselWidth) {
      timelineCarousel.addClass("disabled");
    } else {
      timelineCarousel.removeClass("disabled");
    }
  };

  // *****************
  // Give Carousel container max width of carousel
  // *****************
  const timelineCarouselWidth = $(".timeline-carousel").width();
  const timelineCarouselContainer = $(".timeline-container");
  timelineCarouselContainer.css("maxWidth", timelineCarouselWidth + "px");

  // *****************
  // toggle blog filter list
  // *****************
  $(".blog-filters .filter").on("click", function (e) {
    e.stopPropagation();
    const list = $(this).siblings(".list");
    if (list.hasClass("show")) {
      list.removeClass("show");
    } else {
      list.addClass("show");
    }
  });

  // *****************
  // Hide filter lists if click outside of filter list
  // *****************
  $("body").on("click", function (e) {
    const filterList = $(".blog-filters .filter-wrapper .list");
    if (filterList.hasClass("show")) {
      filterList.removeClass("show");
    }
  });

  // *****************
  // Add overlap class to landing pages where the landing image needs over lapping with
  // the post landing section
  // *****************
  const landingImage = $(".landing-image");
  const contactLandingContainer = $(".contact-landing-container");

  const landingContainerWrapper = $(".landing-container").parent();
  const postLandingSplit = $(".post-landing-split");
  const columnModule = $(".column-module");

  if (landingImage.length > 0) {
    landingContainerWrapper.addClass("overlap");
    postLandingSplit.addClass("extra-padding");
  }

  if (contactLandingContainer.length > 0) {
    columnModule.first().addClass("extra-padding");
    contactLandingContainer.parent().addClass("contact-overlap");
  }

  // *****************
  // Function to remove extra paragraph tag added by WYSIWYG editor
  // at the end of
  // *****************
  const lastParas = document.querySelectorAll(
    ".column-module .row .package .info p:last-child"
  );
  lastParas.forEach((item) => {
    if (item.innerHTML === "") {
      item.classList.add("hide");
    }
  });

  // *****************
  // Set About sub title to purple on about page
  // *****************
  const aboutTitle = document.querySelector(".landing .sub-title");
  if (aboutTitle && aboutTitle.innerHTML === "About") {
    aboutTitle.setAttribute("style", "color:#5a378d");
  }

  // *****************
  // Hide nav bar on scroll
  // *****************
  var didScroll;
  var lastScrollTop = 0;
  var delta = 5;
  var navbarHeight = $("nav").innerHeight();

  $(window).scroll(function (event) {
    didScroll = true;
  });

  setInterval(function () {
    if (didScroll) {
      hasScrolled();
      didScroll = false;
    }
  }, 250);

  function hasScrolled() {
    var st = $(window).scrollTop();

    if (Math.abs(lastScrollTop - st) <= delta) return;

    if (st > lastScrollTop && st > navbarHeight) {
      $("nav").removeClass("nav-down").addClass("nav-up");
    } else {
      if (st + $(window).height() < $(document).height()) {
        $("nav").removeClass("nav-up").addClass("nav-down");
      }
    }

    lastScrollTop = st;
  }

  // *****************
  // Animate elements to fade in and up
  // *****************
  const lazyLoadAnimation = () => {
    $("section .column:not(footer section .column)")
      .find(":not(.nolazy)")
      .children()
      .each(function (index, element) {
        var scrollTop = $(window).scrollTop(),
          elementHeight = $(this).height(),
          elementOffset = $(this).offset().top,
          windowHeight = $(window).height(),
          distance = elementOffset - scrollTop;

        if (!$(this).hasClass("lazy")) {
          gsap.set($(this), {
            opacity: 0,
            y: 100,
          });
        }

        // If the distance from the top of the element to the top of the viewport
        // is less than 2 thirds the height of the viewport then add class to animate in
        if (distance < windowHeight - 100 && !$(this).hasClass("lazy")) {
          $(this).addClass("lazy");
          gsap.to($(this), {
            opacity: 1,
            duration: 0.7,
            y: 0,
            // delay: 0.2,
          });
        }
      });
  };
  // lazyLoadAnimation();

  $(window).scroll(function (event) {
    // lazyLoadAnimation();
  });

  // *****************
  //Blog search
  // *****************
  function blogSearch() {
    $("#s").val($("input[name=search_value]").val());

    let params = "";

    if ($("#sortby").val()) {
      params += "sortby=" + $("#sortby").val();
    }

    if ($("#s").val()) {
      if (params) params += "&";
      params += "search_value=" + $("#s").val();
    }

    if ($("#category").val()) {
      if (params) params += "&";
      params += "category_value=" + $("#category").val();
    }

    if (params) {
      params = "?" + params;
    }

    window.history.replaceState({}, null, "/blog/" + params);
    $.ajax({
      type: "GET",
      url: "/blog/" + params,
      dataType: "html",
      success: function (res) {
        $(".blog-posts").html($(res).find(".blog-posts").html());
      },
    });
  }

  $("form[name=blog-search]").on("submit", function (e) {
    e.preventDefault();

    blogSearch();
    return false;
  });

  $("form[name=blog-search] ul.sortby-list li").on("click", function () {
    $(this).closest(".filter-wrapper").find("button").click();
    $(this).closest(".filter-wrapper").find("button span").text($(this).text());
    $("#sortby").val($(this).data("sortbyvalue"));

    blogSearch();
  });

  $("form[name=blog-search] ul.cat-list li").on("click keydown", function (e) {
    var keyCode = e.keyCode ? e.keyCode || e.which : null;
    if (e.type === "click" || (e.type === "keydown" && keyCode == 13)) {
      $(this).closest(".filter-wrapper").find("button").click();
      $(this)
        .closest(".filter-wrapper")
        .find("button span")
        .text($(this).text());
      $("#category").val($(this).data("categoryvalue"));

      blogSearch();
    }
  });

  const clickableCats = ".category-wrapper .categories span";
  // Function for click on category beniether blog post
  $("body").on("click", clickableCats, function () {
    $(".blog-filters .filter-wrapper").find("button.category--filter").click();
    $(".blog-filters .filter-wrapper")
      .find("button.category--filter span")
      .text($(this).text());
    $("#category").val($(this).data("categoryvalue"));

    blogSearch();
  });

  $("form[name=blog-search] button.search-button").on("click", function (e) {
    e.preventDefault();

    blogSearch();
    return false;
  });
  $("form[name=blog-search]").on("keyup", function (e) {
    if (e.which === 13) {
      e.preventDefault();
      e.stopPropagation();
      $("form[name=blog-search] button.search-button").click();
      return false;
    }

    return true;
  });
  //END Blog search

  //Track blog shares
  if ($(".share-btn").length && $("body").data("postid")) {
    $(".share-btn").on("click keydown", function (e) {
      var keyCode = e.keyCode ? e.keyCode || e.which : null;
      if (e.type === "click" || (e.type === "keydown" && keyCode == 13)) {
        const data = {
          action: "post_is_shared",
          post_id: $("body").data("postid"),
        };
        $.post("/wp-admin/admin-ajax.php", data, function (response) {});
      }
    });
  }
  //END Track blog shares

  //Track blog views
  if ($("body").data("postid")) {
    const data = {
      action: "post_is_viewed",
      post_id: $("body").data("postid"),
    };
    $.post("/wp-admin/admin-ajax.php", data, function (response) {});
  }
  //END Track blog views

  // *****************
  // Detect current page and add active styling to respecting menu item
  // *****************
  var url = window.location.pathname,
    path = url.split("/");
  $(`.nav-menu-${path[1]}`).addClass("active");

  // Copy link to clipboard for sharing post
  let closePopUpTimeout = null;

  $(".share-btn").on("click keydown", function (e) {
    var keyCode = e.keyCode ? e.keyCode || e.which : null;
    if (e.type === "click" || (e.type === "keydown" && keyCode == 13)) {
      var value = $(this).data("share-link");

      var $temp = $("<input>");
      $("body").append($temp);
      $temp.val(value).select();
      document.execCommand("copy");
      $temp.remove();

      const popup = $(this).find(".pop-up");
      popup.addClass("active");

      //Reset timeout if clicked again
      if (closePopUpTimeout) {
        window.clearTimeout(closePopUpTimeout);
      }

      closePopUpTimeout = setTimeout(() => {
        popup.removeClass("active");
      }, 5000);
    }
  });

  // *****************
  // Apply disabled class to all nav menu items to stop the link click refreshing page
  // *****************
  $(".top-nav-menu .nav-menu-items ul li .sub-menu").each(function (
    index,
    element
  ) {
    const subMenuLink = $(this).siblings("a");
    subMenuLink.removeAttr("href");
  });

  // *****************
  // hide and show sub menu pop up
  // *****************
  $(`.nav-menu-items ul li`).on("mouseover", function () {
    if ($(this).children(".sub-menu").length > 0) {
      $(this).addClass("show");
    }
  });
  $(`.nav-menu-items ul li`).on("mouseout", function () {
    if ($(this).children(".sub-menu").length > 0) {
      $(this).removeClass("show");
    }
  });

  $("nav").on("focusin", ".nav-menu-items ul li a ", function (e) {
    $(this)
      .parent(".sub-nav-wrapper")
      .addClass("show")
      .siblings(".sub-nav-wrapper")
      .removeClass("show");

    if (!$(this).hasClass("has-sub-nav")) {
      $(".sub-nav-wrapper").removeClass("show");
    }
  });

  $("body").on("keydown keyup", function (e) {
    var keyCode = e.keyCode || e.which;
    if (keyCode == 9) {
      if (!$(":focus").hasClass("has-sub-nav")) {
        $(".sub-nav-wrapper").removeClass("show");
      }
    }
  });

  // *****************
  // Search via Header
  // *****************
  // Show Hide Search Window
  $(".nav-search-btn, .search-close").on("click keydown", function (e) {
    var keyCode = e.keyCode ? e.keyCode || e.which : null;
    if (e.type === "click" || (e.type === "keydown" && keyCode == 13)) {
      e.preventDefault();
      $(".search-open-icon, .search-close-icon").toggleClass("d-none");
      $(".main-nav").toggleClass("search-down");
      $(".search-section").slideToggle();
      $(".search-field").focus();
      $(".search-section").scrollTop(0);

      if ($("body").hasClass("no-scroll")) {
        // Close slide out menu
        noScroll(false);
        $("body").removeClass("no-scroll");
      } else {
        // Open Close slide out menu
        noScroll(true);
        $("body").addClass("no-scroll");
      }
    }
  });

  // AJAX Request for Search
  let typingTimer = setTimeout(doneTyping, doneTypingInterval); // timer identifier
  const doneTypingInterval = 500; // time in ms (.5 seconds)

  // On keyup
  $(".search-field, .search-field-sm").on("keyup", function () {
    clearTimeout(typingTimer);
    const query = $(this).val();
    $(".search-field, .search-field-sm").val(query);
    typingTimer = setTimeout(doneTyping, doneTypingInterval); // call doneTyping when the user stops pressing keys for .5 seconds
  });

  // User is "finished typing," request the search
  function doneTyping() {
    const query = $(".search-field").val();
    if (query.length >= 3) {
      $(".search-cards-container").load(
        "/wp-content/themes/harpal/templates/modules/search-results.php?query=" +
          query,
        function () {
          if ($(".search-field").val().length < 3) {
            $(".search-cards-container").empty();
          }
        }
      );
    } else {
      $(".search-cards-container").empty();
    }
  }

  // *****************
  // Take Related video's video title from iframe and apply it to title
  // element outside iframe below
  // *****************
  $(".related-video .video iframe").on("load", function () {
    const title = $(this)[0].title;
    const parent = $(this).parent();
    parent.siblings(".title").text(title);
  });

  // *****************
  // Check for side by side class on column module list elements
  // and if so apply class to parents to render list elements side by side
  // *****************
  $(".column ul li .side-by-side-list")
    .parent()
    .parent()
    .addClass("side-by-side-list-parent");

  // *****************
  // Add class to package info to stop long prices extending off screen on larger devices
  // *****************
  const wrapPackagePrice = () => {
    const packageInfo = $(".column-module .package .price");
    if (packageInfo.length <= 0) {
      return;
    }
    packageInfo.each(function () {
      const packageWrapper = $(this).parent();
      if ($(this).width() >= 200) {
        if (window.innerWidth >= 992 && window.innerWidth <= 1250) {
          packageWrapper.addClass("wrap");
        } else {
          packageWrapper.removeClass("wrap");
        }
      }
    });
  };

  // *****************
  // Adjust height of expanded service module when resizing so content fits to container
  // *****************
  const adjustServiceContentHeight = () => {
    const serviceContent = $(".service.expand .service-content");
    const serviceWrapper = $(".service.expand .service-content-wrapper");
    if (serviceContent.length <= 0) {
      return;
    }
    const serviceContentHeight =
      serviceContent && serviceContent[0].clientHeight;
    serviceWrapper[0].style.maxHeight = serviceContentHeight + "px";
  };

  let onResizeEndFunc;
  $(window).resize(function () {
    if (window.innerWidth >= 992) {
      $(".button-nav-cta").html("Book");
    } else {
      $(".button-nav-cta").html("Book");
    }
    removeTimelineCarouselArrows();
    wrapPackagePrice();
    //run this function on end of window resize
    clearTimeout(onResizeEndFunc);
    onResizeEndFunc = setTimeout(adjustServiceContentHeight, 250);
  });

  // *****************
  // Move lets-talk-CTA to after the blog posts, something in the code for the blog page
  // is preventing the data from ACF fields being pulled through
  // *****************
  const blogModules = $("#blog-modules");
  const blogPosts = $("#blog-posts");
  if (blogModules && blogPosts) {
    blogModules.insertAfter(blogPosts);
    blogModules.addClass("show");
  }

  // *****************
  // Move google rating info from widget to rating element in testimonial module
  // *****************
  const testimonials = $(".review-carousel-container");

  if (testimonialLogic) {
    testimonials.each(function () {
      const googleRatingNumber = $(this).find(".wp-google-rating");
      const googleRatingStars = $(this).find(".wp-google-stars");
      const ratingStarsContainer = $(this).find(".rating-stars");
      const ratingStars = $(this).find(".rating-stars .wp-star");
      const ratingTextContainer = $(this).find(".rating-text .rating-number");

      if (googleRatingStars[0]) {
        var removeDimensions = googleRatingStars[0].innerHTML.replaceAll(
          'width="17" height="17"',
          ""
        );

        ratingStarsContainer[0].innerHTML = removeDimensions;
        ratingTextContainer[0].innerHTML = googleRatingNumber[0].innerHTML;
      }
    });
  }

  // *****************
  // Make social icons path relative
  // *****************
  const icons = $("footer img");
  const location = window.location.origin;
  icons.each(function () {
    const newSrc = this.src.replace(location, "");
    this.src = newSrc;
  });

  // Run all these once on load
  wrapPackagePrice();
  removeTimelineCarouselArrows();
  pillsAnimation($, gsap);
  testimonialLogic($);
  carouselWithButtons(
    ".related-blogs",
    ".related-blog",
    ".related-blogs-carousel",
    $,
    1,
    2,
    2
  );
  carouselWithButtons(
    ".related-videos",
    ".related-video",
    ".related-videos-carousel",
    $,
    1,
    2,
    3
  );
});
